import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild, ɵSafeUrl } from '@angular/core';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { Inject } from '@angular/core';
 import { OnDestroy } from '@angular/core'; 
import { Observable, of, Subject } from 'rxjs';
import { filter, switchMap, takeUntil } from 'rxjs/operators';
// import { CallService } from '../doctor-queue/call.service';
import { CallService } from './../../../@core/backend/common/services/videoCall.service';
 
import { TemplateRef } from '@angular/core';
import { NbDialogService } from '@nebular/theme';


import { UserData, User } from './../../../@core/interfaces/common/users';
import { NgZone } from '@angular/core';
import { Message } from './../../../@core/interfaces/patient-services/message';
// import { ChatService } from '../doctor-queue/chat.service';
import { ChatService } from './../../../@core/backend/common/services/VideoChat.service';

import { Location } from '@angular/common';
import { VideoAppointment, VideoAppointmentsData } from '../../../@core/interfaces/patient-services/videoAppointment';

import {ConnectionService} from 'ng-connection-service';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'ngx-patient-videocall',
  templateUrl: './patient-videocall.component.html',
  styleUrls: ['./patient-videocall.component.css']
})
export class PatientVideocallComponent implements OnInit {

  
  callstart:boolean=false;
  docker_field:boolean=false;

  protected readonly unsubscribe$ = new Subject<void>();
  regId: any;
  private tenandId = localStorage.getItem("tenantId");
  private branchId = localStorage.getItem("branchId");
  private suserId = localStorage.getItem("userId");
  private userId='';
  private userName = '';
   // raja
   peerid='';
   docId;
   videocallenable:boolean=true;
   public isCallStarted$: Observable<boolean>;
   private peerId: string;
   @ViewChild('localVideo') localVideo: ElementRef;
   @ViewChild('remoteVideo') remoteVideo: ElementRef;
   participation:Array<any>=new Array();
   ls;
   rs;
   title = 'ClientApp';
   txtMessage: string = '';
   uniqueID: string = new Date().getTime().toString();
   messages = new Array<Message>();
   message_ = new Message();
   _messages:any[]=[];
   data:any;
   flipped:boolean=false;
   users: { name: string, title: string, id: string }[] = [

   ];
   all_massages:any=[];
   doctorName:any='Dr. Henry';
   joinCall:boolean=false;
   @ViewChild('dialog') contentTemplate: TemplateRef<any>;
   meetingInfo:any;
   popup:boolean=false;
   meetingDetailes:any;
   isShowdialog:boolean=false;
   dialogMsg:any="";
     // video call variable by raja 
  btn1="Join";
  btn2="Cancel";    
  meetingData:any;
  VideoAppointmentsData: VideoAppointment;
  VideoAppointmentsList: VideoAppointment[] = [];
  status:any="";
  isConnected:boolean=false;
  isinternetMsg:boolean=false;
  internetMsg:any="";

  msg={
    name:null,date:null,msg:null
  }
  Allmsg:any=[{
    name:"raja",date:"54545",msg:"hi"
  }]
  roomID: any;
   // raja


  constructor(private VideoAppointmentsservice:VideoAppointmentsData,private location:Location,private dialogService: NbDialogService,protected userService: UserData, private router_: Router,  public callService: CallService,private route: ActivatedRoute, private chatService: ChatService, private _ngZone: NgZone,private ConnectionService: ConnectionService){
    this.ConnectionService.monitor().subscribe(isConnected =>  {
      this.isConnected = isConnected;
      if(this.isConnected){
        this.status = "ONLINE";     
        this.openVideoApp();
        this.isinternetMsg=false;
      } else {
        this.isinternetMsg=true;
        this.internetMsg="You are in OFFLINE";
        this.status = "OFFLINE"        
      }
      // alert(this.status);
    });
    this.isCallStarted$ = this.callService.isCallStarted$;
    this.participation=this.callService.data;
    this.callstart=this.callService.callstart;
    this.route.params.pipe(takeUntil(this.unsubscribe$)).subscribe(params => {
      //console.error(params)
      this.docId = params['regId'];
    });
    // this.route.queryParams.subscribe((params: Params) => {
    //   //console.error(params);
    //   // this.regId=params.regId
    //   });
  }

  ngOnInit(): void {
    console.log(this.isShowdialog)
    // this.chatService.startConnect();
    this.joinCall=false;
    this.meetingDetailes=JSON.parse(window.localStorage.getItem("MeetingDetailes"));
    // this.mee
    // this.subscribeToEvents();
  }

  async ngAfterViewInit() {
  
    ////alert("afterinit");
      // await this.sleep(2000);
       this.callService.localStream$
       .pipe(filter(res => !!res))
       .subscribe(stream => this.localVideo.nativeElement.srcObject = stream)
      this.callService.remoteStream$
       .pipe(filter(res => !!res))
       .subscribe(stream => this.remoteVideo.nativeElement.srcObject = stream)
       this.callstart=this.callService.callstart;
      this.serviceCall();
  } 

  onDialogClose(btn){
    // alert(btn);
   if(this.btn2!="OK"){ 
    if(btn=="Ok"){

      console.log("Data = ",this.meetingData)
      window.localStorage.setItem("iAm","true");
      this.joinCall=false;
      var message_ = new Message(); 
      message_.clientuniqueid = this.uniqueID;
      message_.type = "waiting";
      message_.message = "Patient is waiting";// this.txtMessage;
      message_.date = new Date();
      message_.userId=this.meetingData?.doctor.id+","+this.suserId+","+this.meetingData?.appointmentId+","+this.regId;//.toString();
      message_.tenantId=this.tenandId;
      message_.userName=this.meetingData?.patientRegistration.firstname;
      message_.chatType='waiting';
      this.chatService.sendMessage(message_);
      this.isShowdialog=false;
      this.location.back();
    }else if(btn==="Join"){
      this.isShowdialog=false;
      this.route.params.pipe(takeUntil(this.unsubscribe$)).subscribe(async params => {
        this.docId = params['regId'];
          //console.error(params);
          if(params['roomId']){ 
            this.callService.meeting_start(params['roomId'],"false");
            await this.sleep(1500)
            // this.sendvideomsg(params['roomId'],'Patient is waiting in the lobby.  Do you want to admit?',"patient");
            this.roomID=params['roomId'];
            this.callService.destroyPeer();
            this.peerId = this.callService.initPeer("null");

            if(this.peerId)
              this.openVideoApp();          

          }
        });

    }
    if(btn=="Confirm" || this.btn2=="COnfirm"){
      // alert("COnfirm")
      this.callService.closeMediaCall();
      this.location.back();
    }
  }
    this.isShowdialog=false;
  }

  public async serviceCall(){
  this.peerId=null;
  
  this.route.params.pipe(takeUntil(this.unsubscribe$)).subscribe(async params => {
    this.docId = params['regId'];
      //console.error(params);
      if(params['roomId']){
        
        this.roomID=params['roomId'];
        this.callService.destroyPeer();
        await this.sleep(500);
        this.peerId = this.callService.initPeer("null");
        await this.sleep(1000);
        if(this.peerId){
          this.openVideoApp();          
        // this.callService.meeting_start(params['roomId'],"false");

          ////alert(this.peerId)//  uncomment

          // this.callService.establishMediaCall(params['roomId'])
           
        }
      }
  });
  
  this.fetchUsertype();
}

 
// edit by Raja


openvchat(){
  this.chatService.chatbox=!this.chatService.chatbox;
}


  // edit by Raja
  async openVideoApp(regID?: any): Promise<void> {
    // //////alert("test");
    this.videocallenable=true;
    var data=this.callService.get_data();
    console.error(data);
   if(data[0]!=null || !!localStorage.getItem("peer_id")){
          // this.callService.initPeer(data[2]);
          this.callstart=true;
          await this.sleep(1000);
          this.callService.establishMediaCall(localStorage.getItem("peer_id")); 
          await this.sleep(1000);
   }else{
    var data1=JSON.parse(window.localStorage.getItem("MeetingDetailes"));
    console.log("++++++++++++++++++++++++++ ",data)
    if(data1.eventStatus=="Started"){
      window.localStorage.removeItem("iAm"); 
      //alert("meeting stated ="+data[i].id)
      var id=data1.id;
      this.meetingData=data1;
      this.btn1="Join";
      this.btn2="Cancel";
      this.isShowdialog=true;
      this.dialogMsg="Do you want to join?"; 
    }else{
      this.meetingData=data1;
      this.btn1="Ok";
      this.btn2="Close";
      this.isShowdialog=true;
      this.dialogMsg="Waiting for the doctor to start call !"; 
    }
   }
  //  this.doctorName=window.localStorage.get("doctorName");
    // this.sendMessage(regID);
    // window.open("https://ievangelist-videochat.azurewebsites.net/", '_blank', 'location=yes,left=200,height=1000,width=1000,scrollbars=yes,status=yes');
  }


  public async endCall() { 
    this.btn1="Confirm";
    this.btn2="Close";
    this.dialogMsg="Do you want to leave meeting ?"
    this.popup=true;
    this.isShowdialog=true;
    // this.dialogService.open(this.contentTemplate, { context: 'Do you want to leave meeting ?', closeOnBackdropClick :false, closeOnEsc:false, autoFocus:false })
    // .onClose.subscribe(() => { 
    // }); 
  }
  sharescreen(){
    this.callService.printpeer();
  }
  back(){
    this.videocallenable=false;
  }
  sleep(ms) {​​​​​​​​
    return new Promise(resolve=>setTimeout(resolve, ms));
  }​​​​​​​​
  public senddata(){
    this.callService.sendData();
  }
  public sendinvite(data){
    var data1=this.callService.callans(1);
    ////////console.error(data1);
  }

  public local_mute(){
    this.callService.local_toggleMic();
  }

  public local_video(){
    this.callService.local_toggleVideo();
  }


  public remote_mute(){
    this.callService.remote_toggleMic();
  }

  public remote_video(){
    this.callService.remote_toggleVideo();
  }

  getPatRegDet(event: any): void
  {
    //console.log(event);
  }

  sendMessage(event: any, userName: string, avatar: string, reply: boolean) {
    const files = !event.files ? [] : event.files.map((file) => {
      return {
        url: file.src,
        type: file.type,
        icon: 'file-text-outline',
      };
    });

    this._messages.push({
      text: event.message,
      date: new Date(),
      reply: reply,
      type: files.length ? 'file' : 'text',
      files: files,
      user: {
        name: this.userName,
        avatar: '../.././../../assets/images/userav.png',
      },
    });

      this.message_ = new Message();
      this.message_.clientuniqueid = this.uniqueID;
      this.message_.type = "sent";
      this.message_.message = event.message;// this.txtMessage;
      this.message_.date = new Date();
      this.message_.userId=this.userId+","+this.suserId;//.toString();
      this.message_.tenantId=this.tenandId;
      this.message_.userName=this.userName;
      this.message_.chatType='';
      this.messages.push(this.message_);
      var data=this.all_massages;
      //////console.log(this.all_massages);
      if(this.all_massages.length==0){
        //////console.log("new msg 1=",this.userId);
        this.all_massages.push({'id':this.userId,'message':this._messages});
      }else{
        var ii;
        var data;
        for(var i=0;i<this.all_massages.length;i++){
          if(this.all_massages[i].id==this.userId) {
            ii=i;
            data=this.all_massages[i].message
          }
         }
        var data=this.all_massages.filter(e => e.id === this.userId);
        //////console.log("sttus=",data," array inside value=",this.all_massages.filter(e => e.id === this.userId));
            if(data.length==0){
              //////console.log("new msg 2");
              this.all_massages.push({'id':this.userId,'message':this._messages});
            }else{
              //////console.log("old msg");
               if(ii!=null) {
                this.all_massages[ii].message=this._messages;
                this._messages=this.all_massages[ii].message;
               }
            }
     }
      this.chatService.sendMessage(this.message_);
      this.txtMessage = '';
      //////console.error(this.all_massages);


  }

  toggleView() { this.flipped = !this.flipped; }

  chatUser(user){
    //////console.log("user click = ",user);
    this._messages=[];
    this.userName=user.name;
    this.userId=user.id;
    this.toggleView();
    //////console.log(" 1=this user = ",user.id," msg = ", this.all_massages);
    for (var i=0;i<this.all_massages.length;i++) {
          if(this.all_massages[i].id==user.id){
            //////console.log("2=user id=",user.id,", chat already there", this.all_massages);
            this._messages=this.all_massages[i].message;
          }
        }
        //////console.log("amsg set=",this._messages);

  }
  sendMessage1(): void {
    // this.txtMessage="Raja";
    if (this.txtMessage) {
      this.message_ = new Message();
      this.message_.clientuniqueid = this.uniqueID;
      this.message_.type = "sent";
      this.message_.message = this.txtMessage;
      this.message_.date = new Date();
      this.messages.push(this.message_);
      this.chatService.sendMessage(this.message_);
      this.txtMessage = '';
    }
  }
  private subscribeToEvents(): void {
    // ////alert("1");
    this.chatService.messageReceived.subscribe((message: Message) => {
      this._ngZone.run(async () => {
        // this._messages=[];
        console.log("rec message",message );

        if (message.clientuniqueid !== this.uniqueID) {
          if(message.chatType=="video_invite"){
            if(message.userId===this.peerid || message.userId===this.peerId ){
                //console.log("receive msg = ", message);
                // await this.sleep(3000)
                var data_=message.message.split("@");
                //console.error(data_);
                if(data_[1]=="patient"){
                  // ////alert("confirm");
                }else{
                  if(data_[0]=="true"){
                    // ////alert("allowed");
                    this.updateVideoAppoiment();
                    this.callService.establishMediaCall(message.userId);
                  }else{
                    ////alert("Doctor is not allowed");
                    // await this.sleep(1000)
                    // this.back();
                    this.btn1="Ok";
                    this.btn2="Confirm";
                    this.dialogMsg="Doctor Not Allowed You"
                    this.popup=true;
                    this.isShowdialog=true;
                    // this.callService.destroyPeer();
                    // this.peerId = this.callService.initPeer("null");
                    this.peerid=this.peerId;
                  }
                }
            }
          }else if(message.chatType == "vchat"){
            if(this.roomID==message.userId){
            console.log("vchat",message,this.roomID);
            var msg={
              name:message.userName,
              date:message.date.toString(),
              msg:message.message
            }
            this.Allmsg.push(msg)
            }
          }else{
          message.type = "received";
          var data1=message.userId;
          //////console.log(this.all_massages);
          if(this.suserId==data1.split(",")[0]){
            this.userId=data1.split(",")[1];
            //////console.log("msg=")
              this._messages.push({
                  text: message.message,
                  date: new Date(),
                  reply: false,
                  user: {
                    name: message.userName,
                    avatar: '../.././../../assets/images/userav.png',
                  },
                });
                if(this.all_massages.length==0){
                  //////console.log("new msg 1");
                  this.all_massages.push({'id':this.userId,'message':this._messages});
                }else{
                  var ii;
                  var data;
                  for(var i=0;i<this.all_massages.length;i++){
                    if(this.all_massages[i].id==this.userId) {
                      ii=i;
                      data=this.all_massages[i].message
                    }
                   }
                    //////console.log(this.all_massages);
                    var data=this.all_massages.filter(e => e.id === this.userId);
                    // //////console.log("sttus=",data," array inside value=",this.all_massages.filter(e => e.id === this.userId));
                      if(data.length==0){
                        //////console.log("new msg 2");
                        this.all_massages.push({'id':this.userId,'message':this._messages});
                      }else{
                        //////console.log("old msg");
                        this.all_massages[ii].message=this._messages
                      }
                }
                for(var i=0;i<this.all_massages.length;i++){
                  for(var j=0;j<this.users.length;j++){
                      if(this.all_massages[i].id==this.users[j].id) {
                        //////console.log("old user set ",this.all_massages[i].message);
                        this._messages=this.all_massages[i].message
                      }
                    }
                  this.mesage_set(this.all_massages[i].id,this.all_massages[i].message.length)
                 }
                 //////console.log(this.all_massages);
                //  this.m
                 this.messages.push(message);
            }
          }
        }
      });
    });
  }

  // open(dialog: TemplateRef<any>) {
  //   this.dialogService.open(dialog, { context: 'Patient is waiting for lobby, you can admit ?', closeOnBackdropClick :false, closeOnEsc:false, autoFocus:false }).onClose.subscribe(data => ////alert(name));;
  // }
  _close(check){
  //  this.dialogService.

  this.joinCall=check;
  this.popup=false;
  this.isShowdialog=false;
            ////alert("doctor confirm = "+this.lobbyChk)
  if(this.joinCall) {
    this.videocallenable=false;
    // document.getElementById("close").click();
    if(check==false){
      this.router_.navigate(["/pages/patientservices/app/"+this.regId]);
    }
      try{
        this.callService.closeMediaCall();
      }catch(ex){

      }
      this.location.back();
      // this.router_.navigate(["/pages/patientservices/appointments"]);
    }
    this.isShowdialog=false;
  //  this.dialogService.


  }
  fetchUsertype() {
    this.users=[];
    this.userService.userList(`users/userlist/${this.tenandId}`).pipe(takeUntil(this.unsubscribe$)).subscribe((datas: any) => {
      this.data = datas;
      //////console.log(datas)
      for(let data of datas){
        if(this.userId==data.id){
          this.userName=data.firstName+" "+data.lastName;
          window.localStorage.setItem("uName",this.userName);
	        this.userId=data.id;
        }else{
          this.users.push({name: data.firstName+" "+data.lastName, title: 'No new message', id: data.id})
        }
        //this.users.push({name: data.firstName+" "+data.lastName, title: 'online'})
      }
      //////console.log("data..............",this.data)

    }, (error) => {

    }, () => {

    });
  }

  mesage_set(id,count){
    //////console.log("users ==",this.users)
    for(var i=0;i<this.users.length;i++){
      if(this.users[i].id==id){
          this.users[i].title=count +" new messages";
      }
    }
  }


  sendvideomsg(peerId,msg,type){
    this.peerid=peerId;
    this.message_.clientuniqueid = this.uniqueID;
    this.message_.type = '';
    this.message_.message = msg+"@"+type;// this.txtMessage;
    this.message_.date = new Date();
    this.message_.userId= peerId;//.toString();
    this.message_.tenantId=this.tenandId;
    // ////alert(JSON.stringify(window.localStorage.getItem("uName")));
    this.message_.userName="Patient";
    this.message_.chatType='video_invite';
    // //console.log("send msg = ",this.message_);
    this.chatService.sendMessage(this.message_);
  }

  receiver_patient(peerId){
    this.callService.establishMediaCall(peerId)
  }

  getUser(id){
    var data=this.users.filter(e => e.id === id);
    // ////alert(JSON.stringify(data[0]));
    return data[0];
  }

  ngOnDestroy(): void {
    this.unsubscribe$.unsubscribe();
    this.callService.closeMediaCall();
  }
  
  async openPIP(){
    var video:  VideoElement = this.remoteVideo.nativeElement;
    await video.requestPictureInPicture();
        // video.addEventListener('play', async (e) => {
          // await video.requestPictureInPicture();
        // })
  }

  sendMSG(msg){
      var message_ = new Message();
      message_.clientuniqueid = this.uniqueID;
      message_.type = "vchat";
      message_.message = msg;// this.txtMessage;
      message_.date = new Date();
      message_.userId=this.roomID;
      message_.tenantId=this.tenandId;
      message_.userName=this.meetingData?.patientRegistration.firstname;
      message_.chatType='vchat';
      console.log(message_);
      this.chatService.sendMessage(message_);
  }
  get apiUrl(): string {
    return environment.apiUrl;
  }
  
  public updateVideoAppoiment(){
    var data=JSON.parse(window.localStorage.getItem("MeetingDetailes"));
    window.localStorage.removeItem("meeting_");
    window.localStorage.setItem("meeting_",JSON.stringify(data));
    data.patientIP=this.callService.getIP;
    data.patientDeviceType=this.callService.getDeviceType;
    data.patientOS=this.callService.getOS;
    data.patientBrowser=this.callService.getBrowser;
    data.patientBrowserVersion=this.callService.getBrowserVersion;
    console.log("video appoinment data = ",data);
    this.VideoAppointmentsservice.update(`${this.apiUrl}/videoAppointments/${this.tenandId}/${this.branchId}/${data.id}`,data).pipe(takeUntil(this.unsubscribe$)).subscribe((data_: any) => {
      let responseList = (data_);
      console.log("update video appoinment data = ",data_);
    }, (error) => {
      console.log("update video appoinment error = ",error);
    }, () => {
    });
  }

}
interface VideoElement extends HTMLVideoElement {
  requestPictureInPicture(): any;
}